
import './Links.css';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

function Links({ classeCSS, toggleExpand, links, isExpanded}) {
    const { t: tChat } = useTranslation('chat');

    // useEffect para expandir o componente sempre que a lista de links mudar
    useEffect(() => {
        if (links.length > 0 && !isExpanded) {
            toggleExpand(); // Expande o componente automaticamente
        }
    }, [links]); // Dispara o efeito sempre que 'links' mudar

    return (
        <div className={classeCSS} onClick={toggleExpand}>
            
            <div className='header-links'>
                <img src="/imagens/link.svg" alt={tChat('linkIcon')} className="link-icon" />
                {tChat('links')}
            </div>
            
            <ul className="links-list">
                {links.length > 0 && (
                    links.map((linkItem, index) => (  // Mapeia os links se a lista não estiver vazia
                        <li key={index}>
                            <a 
                            href={linkItem.link}
                            target="_blank" 
                            rel="noopener noreferrer"
                            >
                                {linkItem.filename}
                            </a>
                            <hr />
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
}

export default Links;
